import { gql, TypedDocumentNode } from "@apollo/client";

import {
  SendExportNoteEmailMutation,
  SendExportNoteEmailMutationVariables,
} from "./SendExportNoteEmail.generated";

const SEND_EXPORT_NOTE_EMAIL: TypedDocumentNode<
  SendExportNoteEmailMutation,
  SendExportNoteEmailMutationVariables
> = gql`
  mutation sendExportNoteEmail(
    $toEmail: String
    $grantedNoteUuid: String
    $isForAssistant: Boolean
    $specialInstructions: String
    $areAttachmentsIncluded: Boolean
    $shouldEmbedEmailExports: Boolean
  ) {
    sendExportNoteEmail(
      toEmail: $toEmail
      grantedNoteUuid: $grantedNoteUuid
      isForAssistant: $isForAssistant
      specialInstructions: $specialInstructions
      areAttachmentsIncluded: $areAttachmentsIncluded
      shouldEmbedEmailExports: $shouldEmbedEmailExports
    ) {
      ok
    }
  }
`;

export default SEND_EXPORT_NOTE_EMAIL;
